import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { SharedLinesTextEllipsisStyle } from 'mui/components/sharedStyles/textStyles';
import Link from 'mui/components/elements/Link';

export const StyledLocationName = styled(Typography)(
  ({ theme }) => `
    margin-bottom: ${theme.DS_spacing(['xs'])};
    word-break: break-all;

    &.ellipsis {
      margin-bottom: ${theme.DS_spacing(['xxs'])};
      ${SharedLinesTextEllipsisStyle(1)};
    }
    
    ${theme.breakpoints.up('lg')} {
      word-break: break-word;
   
      &.ellipsis {
        ${SharedLinesTextEllipsisStyle(2)};
      }
    }
  `,
);

export const StyledLocationAddress = styled(Typography)(
  ({ theme, $isBookingFunnel }) => `
    margin-bottom: ${theme.DS_spacing(['xxs'])};
    color: ${theme.DS_palette.text.secondary};
    width: 90%;

    &.ellipsis {
      height: ${$isBookingFunnel ? 'auto' : '48px'};
      ${SharedLinesTextEllipsisStyle(2)};
    }
    
    ${theme.breakpoints.up('lg')} {
      width: %;
      line-height: ${$isBookingFunnel ? 'auto' : '28px'};
  
      &.ellipsis {
        height: ${$isBookingFunnel ? 'auto' : '56px'};
      }
    }
  
  `,
);

export const StyledPhoneLink = styled(Link)(
  ({ theme }) => `
    color: ${theme.DS_palette.primary.main};
  `,
);

export const StyledLocationPhone = styled(Typography)(
  ({ theme }) => `
    margin-bottom: 0.25rem;
    
    ${theme.breakpoints.up('lg')} {
      margin-bottom: 0.75rem;
    }
  `,
);

export const StyledIconTextWrapper = styled('div')`
  display: flex;
  gap: 5px;
  align-items: center;

  svg {
    fill: none;

    :last-of-type {
      margin-top: -14px;
    }
  }
`;

export const StyledClipboardWrapper = styled('div')`
  &:hover {
    cursor: pointer;
  }
`;
